import { RouteObject } from 'react-router';
import PermissionGuard from '../gate/PermissionGuard';
import MarketplaceGuard from '../gate/MarketplaceGuard';
import { ADDON_BUY_PERMISSIONS } from '@/features/marketplace/addons';
import { MARKETPLACE_ACCESS_PERMISSIONS } from '@/features/marketplace';
import { PERMISSIONS } from '@/shared/constants';

const ADDON_BUY_PERMISSION_LIST = Array.from(ADDON_BUY_PERMISSIONS);

export const marketplaceRoutes: RouteObject[] = [
	{
		path: 'marketplace',
		lazy: async () => {
			const { default: Page } = await import('@/features/marketplace/pages/MarketplacePage');
			return {
				Component: () => (
					<PermissionGuard
						permission={MARKETPLACE_ACCESS_PERMISSIONS}
						mode='any'
					>
						<Page />
					</PermissionGuard>
				),
			};
		},
		children: [
			{
				index: true,
				element: <MarketplaceGuard />,
			},
			{
				path: 'addons',
				lazy: async () => {
					const { default: Page } = await import(
						'@/features/marketplace/addons/pages/BePremiumPage'
					);
					return {
						Component: () => (
							<PermissionGuard
								permission={ADDON_BUY_PERMISSION_LIST}
								mode='any'
							>
								<Page />
							</PermissionGuard>
						),
					};
				},
			},
			{
				path: 'devices',
				lazy: async () => {
					const { default: Page } = await import(
						'@/features/marketplace/devices/pages/DeviceCatalogPage'
					);
					return {
						Component: () => (
							<PermissionGuard permission={PERMISSIONS.DEVICES_MARKETPLACE_READ}>
								<Page />
							</PermissionGuard>
						),
					};
				},
			},
		],
	},
];
